import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CSVLink } from "react-csv";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// import Moment from 'react-moment';
import "moment-timezone";
import { format } from "date-fns";
// import ReactHtmlParser from 'react-html-parser';

import { ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, ROUTE_CLIENT_REFRESH, PAGENUMROWS_AFFILIATE, PAGING_END_INDEX, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, SEARCH_TEXT_COUNT, EVENT_STATUS, ROUTE_AFFILIATE_EVENTS, QUOTE_STATUS, QUOTE_SENT, ROUTE_AFFILIATE_SCHEDULE_SHIFT, EVENT_STATUS_CANCELLED, EVENT_STATUS_ESTIMATION, EVENT_STATUS_QUOTE_REQUESTED, EVENT_STATUS_QUOTE_SENT, EVENT_STATUS_QUOTE_DECLINED, EVENT_STATUS_REESTIMATION, LOGIN_SUPER_ADMIN_GROUP 
} from "../../../configs/staticConfigs";

import { MSG_NOT_FOUND, MSG_NOT_GENERATED, MSG_CSV_DOWNLOAD_ERROR } from "../../../configs/msgConfigs";
import {
  LBL_APP_NAME, LBL_EVENT, LBL_EVENTS, LBL_QUOTES, LBL_SLNUM, LBL_EVENT_TITLE, LBL_AFFILIATE, LBL_LOCATION, LBL_EVENT_STATUS, LBL_TEAM_COUNT, LBL_SHIFT_COUNT, LBL_PO, LBL_QUOTE_NO,  LBL_Total_COST, LBL_CURRENCY_POUND,LBL_APPLY, LBL_DOWNLOAD, FILE_CSVDOWNLOAD_QUOTES, FILE_CSVDOWNLOAD_EVENTS
} from "../../../configs/labelConfigs"; // LBL_LIST_VIEW, LBL_CALENDAR_VIEW, LBL_SCHEDULE_SHIFT,

import * as types from "../../../actions";
import { clearAction, fromDashboard, serverTimeAction } from "../../../actions/commonActions";
import { eventListAction, eventListDownloadAction } from "../../../actions/eventActions";

import { getSortClass } from "../../../utils/commonUtilities";
import { getUserTimeZone } from "../../../utils/userGroupUrlCheck";
import { checkPermissions } from "../../../utils/permissions";
import { converDateToLocal } from "../../../utils/commonUtilities";

import Toast from "../../commons/helpers/toast";
// import EventCalendarView from "./eventCalendarView";
import Paginator from "../../commons/helpers/paginator";
import {
  checkEventNotCancelled,
  showScheduleBtn,
  showCompleteEventBtn,
} from "../../event/eventStatusCheck";
import CustomMultiSelect from '../../../components/commons/helpers/customMultiSelect';

let eventStatusData = [];
let eventStatusDataMaster = [];
let quotePageEventStatusData = [];
let quotePageEventStatusDataMaster = [];
let arrQuoteEventsStatus = [EVENT_STATUS_CANCELLED,EVENT_STATUS_ESTIMATION, EVENT_STATUS_QUOTE_REQUESTED, EVENT_STATUS_QUOTE_SENT, EVENT_STATUS_QUOTE_DECLINED, EVENT_STATUS_REESTIMATION]; 
EVENT_STATUS.forEach(item => { 
    if(Number(item.statusCode)!==Number(EVENT_STATUS_ESTIMATION)) {
        eventStatusData.push({value:item.statusCode,label:item.statusString}); 
        eventStatusDataMaster.push({value:item.statusCode,label:item.statusString});
    }
    if(arrQuoteEventsStatus.includes(Number(item.statusCode))) {
        quotePageEventStatusData.push({value:item.statusCode,label:item.statusString}); 
        quotePageEventStatusDataMaster.push({value:item.statusCode,label:item.statusString}); 
    }
});

class ClientEvents extends Component {
  constructor(props) {
    super(props);

    let date = new Date();
    // Add a day
    date = format(new Date(date.setDate(date.getDate() + 1)), "yyyy-MM-dd");
    this.state = {
      profileCurrency: "",
      activePage: 1,
      startIndex: 0,
      endIndex: PAGING_END_INDEX,
      activeRowId: 0,
      perPageCount: PAGENUMROWS_AFFILIATE,
      sortField: "start_date",
      sortOrder: "",
      isFilterOn: false,
      toastMessage: "",
      toastFlag: false,
      toastSuccess: true,
      searchQuote: "",
      
      eventData: {
        affiliateId: null,
        clientId: null,
        clientContactId: null,
        eventTitle: null,
        quoteNumber: "",
        locationId: null,
        location: "",
        googleLocation: "",
        venue: "",
        streetOne: "",
        streetTwo: "",
        city: null,
        state: null,
        country: null,
        postcode: null,
        startDate: date,
        endDate: date,
        startTime: "00:00",
        endTime: "23:59",
        poNumber: "",
        noLocationFound: false,
        eventNotes: "",
        status: "",
        created_by: "",
      },
      profileId: "",
      assuserId: "",
      eventStatus: EVENT_STATUS,
      quoteStatus: QUOTE_STATUS,
      eventId: "",
      eventDeleteTitle: "",
      eventDataForShift: {
        eventId: "",
        eventTitle: "",
        clientId: "",
        affiliateId: "",
        location: "",
        venueName: "",
        streetOne: "",
        streetTwo: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
        startDate: "",
        endDate: "",
        googleLocation:""
      },
      eventIdSelected: "",
      isClientPage: false,
      isSuperAdminPage: false,
      disableLocationSearch: false,
      isListLayout: true,
      isEvent: 1,
      userGroup: 0,
      filterClicked: 0,
      resetFilterClicked: 0,
      applyFilterClicked: 0,
      applyFilter: 1,
      filtersData: {},
      completeEventId: 0,
      loadPreviewQuoteEventId: 0,
      newClientContactAdded: 0,
      addContactClicked: 0,
      saveFormDataClicked: 0,
      exportQuote: [],
      reloadCalendarView: 0,
      initialValidation: false,
      sameAsProfileSign: true,
      activeShiftId: 0,
      defaultStartDate: date,
      eventStatusIds: [],
      quoteStatusIds: [], 
      eventStatusData:[],
      eventListAdded:false,
      eventClicked: false,
      selQuoteNumber: '',
      selEventId: ''
    };

    this.setToasterState = this.setToasterState.bind(this);
  }


  onCloseToastPop = () => {
    // USED FOR POPUP clientContactAdd
    this.setState({ toastFlag: false, toastMessage: "", toastSuccess: false });
  };

  setToasterStatePop = (isEnabled, message, isSucces, isAutoHide = true) => {
    this.setState({
      toastFlag: isEnabled,
      toastMessage: message,
      toastSuccess: isSucces,
    });
    if (isAutoHide) {
      setTimeout(() => {
        this.onCloseToastPop();
      }, 3000);
    }
  };

  scheduleShiftClick = (eventId) => {
    this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + "/" + eventId);
  };

  onEventStatusDataChange = (selectedStatus,selType) =>{
    let selStatus = [];
    selectedStatus.forEach((item) => {
        selStatus.push(parseInt(item.value,10));
    });
    
    if(selType==='event')  this.setState({eventStatusIds:selStatus});
    else if(selType==='quote')  this.setState({quoteStatusIds:selStatus});
}

  applyFilters = (filtersData) => {
    // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA
    let filterApplied = 0;
    if (filtersData.filtersSelected > 0) filterApplied = 1;
    let sortOrder = "";
    let sortField = "start_date";
    if (filtersData.selectedStartDate !== 0) sortField = "start_date";
    this.setState(
      {
        activePage: 1,
        sortOrder: sortOrder,
        sortField: sortField,
        searchShift: "",
        applyFilter: filterApplied,
        filtersData: filtersData,
      },
      () => {
        if (this.state.isListLayout) {
          this.props.eventListAction({
            isEvent: this.state.isEvent,
            pageSize: this.state.perPageCount,
            page: this.state.activePage,
            column: this.state.sortOrder + this.state.sortField,
            search: "",
            applyFilter: 1,
            filtersData: this.getFilterData() 
          });
        } else {
          let cView = this.state.reloadCalendarView + 1;
          this.setState({ reloadCalendarView: cView });
        }
      }
    );
  };

  getFilterData = () => { 
    return {cancelReasons:[], departments:[], affiliateIds:[], clientsIds:[this.props.client_id], eventIds:[], locIds:[], eventStatIds:this.state.eventStatusIds, quoteStatIds:[], selDateType:0, selectedStartDate:0, selectedEndDate:0, filtersSelected:1, shiftTimeChangeRequest:false, selStaffAssigned:''}
  }

  onPagePrevious = (e) => {
    const { startIndex, endIndex } = this.state;
    let previousPage = startIndex + 1 - PAGING_END_INDEX;
    if (this.state.applyFilter > 0) {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: previousPage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.getFilterData()
      });
    } else {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: previousPage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.getFilterData()
      });
    }
    if (startIndex === 0) {
      this.setState({
        activePage: previousPage,
        startIndex: startIndex,
        endIndex: endIndex,
      });
    } else {
      this.setState({
        activePage: previousPage,
        startIndex: startIndex - PAGING_END_INDEX,
        endIndex: endIndex - PAGING_END_INDEX,
      });
    }
  };

  onPageUp = (e) => {
    if (this.state.applyFilter > 0) {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: e.target.id,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.getFilterData()
      });
    } else {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: e.target.id,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.getFilterData()
      });
    }
    this.setState({
      activePage: Number(e.target.id),
    });
  };

  onPageNext = (e) => {
    const { startIndex, endIndex } = this.state;
    const { totalPage } = this.props;

    let nextPage = startIndex + 1 + PAGING_END_INDEX;
    if (this.state.applyFilter > 0) {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: nextPage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.getFilterData() 
      });
    } else {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: nextPage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.getFilterData()
      });
    }

    if (endIndex === totalPage || totalPage <= PAGING_END_INDEX) {
      this.setState({
        activePage: nextPage,
        startIndex: startIndex,
        endIndex: endIndex,
      });
    } else {
      this.setState({
        activePage: nextPage,
        startIndex: startIndex + PAGING_END_INDEX,
        endIndex: endIndex + PAGING_END_INDEX,
      });
    }
  };

  onSort = (event, sortKey) => {
    let sOrder = "";
    if (this.state.sortField === sortKey) {
      sOrder = this.state.sortOrder === "-" ? "" : "-";
      if (this.state.applyFilter > 0) {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: sOrder + this.state.sortField,
          search: this.state.searchQuote,
          applyFilter: 1,
          filtersData: this.getFilterData()
        });
      } else {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: sOrder + this.state.sortField,
          search: this.state.searchQuote,
          applyFilter: 1,
          filtersData: this.getFilterData()
        });
      }
      this.setState({ sortOrder: sOrder });
    } else {
      this.setState({ sortField: sortKey });
      if (this.state.applyFilter > 0) {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: this.state.sortOrder + sortKey,
          search: this.state.searchQuote,
          applyFilter: 1,
          filtersData: this.getFilterData() 
        });
      } else {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: this.state.sortOrder + sortKey,
          search: this.state.searchQuote,
          applyFilter: 1,
          filtersData: this.getFilterData() 
        });
      }
    }
  };

  onModalFormReset = () => {
    let date = this.state.defaultStartDate;
  };

  onCloseToast = () => {
    this.setState({ toastFlag: false, toastMessage: "", toastSuccess: false });
  };

  onSearchQuote = (e) => {
    let sVal = e.target.value;
    this.setState({ searchQuote: sVal }, () => {
      if (String(sVal).length >= 3 || String(sVal).length === 0) {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: String(sVal).length > 0 ? 1 : this.state.activePage,
          column: this.state.sortOrder + this.state.sortField,
          search: this.state.searchQuote,
          applyFilter: this.state.applyFilter,
          applyFilter: 1,
          filtersData: this.getFilterData() 
        });
      }
    });
  };

  setToasterState(isEnabled, message, isSucces, autoHide = true) {
    this.setState({
      toastFlag: isEnabled,
      toastMessage: message,
      toastSuccess: isSucces,
    });
    if (autoHide) {
      setTimeout(() => {
        this.onCloseToast();
      }, 5000);
    }
  }


  onShowFilterBy = () => {
    return true; 
    let filterClicked = this.state.filterClicked + 1;
    this.setState((prevState) => ({
      isFilterOn: !prevState.isFilterOn,
      filterClicked: filterClicked,
    }));
  };

  onSearchLocation = (query) => {
    let { eventData } = this.state;
    if (query.length >= SEARCH_TEXT_COUNT) {
      this.props.quoteEventLocationListAction({
        pageSize: "",
        page: 0,
        column: "-id",
        search: query,
        affiliateId: eventData.affiliateId,
      });
    }
  };


  onEventLayoutToggle = (e, value) => {
    this.setState({ isListLayout: value });
    this.onApplyFilterButton();
  };


  reloadEventList = () => {
    this.props.eventListAction({
      isEvent: this.state.isEvent,
      pageSize: this.state.perPageCount,
      page: this.state.activePage,
      column: this.state.sortOrder + this.state.sortField,
      search: this.state.searchQuote,
      applyFilter: 1,
      filtersData: this.getFilterData() 
    });
  };

  showEventDetails = (e,eventId) => {
    this.props.history.push(ROUTE_AFFILIATE_EVENTS+'/'+eventId);
  }

  onApplyFilterButton = () => {
    this.props.eventListAction({
      isEvent: this.state.isEvent,
      pageSize: this.state.perPageCount,
      page: this.state.activePage,
      column: this.state.sortOrder + this.state.sortField,
      search: this.state.searchQuote,
      applyFilter: 1,
      filtersData: this.getFilterData() 
    });
  }

  onCSVDownload = () => {
    this.props.eventListDownloadAction({
      isEvent: this.state.isEvent,
      pageSize: 0,
      page: 0,
      column: this.state.sortOrder + this.state.sortField,
      search: this.state.searchQuote,
      csvDownload: 1,
      applyFilter: 1,
      filtersData: this.getFilterData()
    });
  };


  componentDidUpdate(prevProps) {
    const {
      isFilterOn,
      activity,
      status,
      eventData,
      eventId,
      eventPopupId,
      clientEventsTabClicked,
      client_id,
      downloadEvents,
      downloadStatus,
      downloadActivity,
    } = this.props;
    let arrDn = [];
    
    if(clientEventsTabClicked > 0 && prevProps.clientEventsTabClicked!==clientEventsTabClicked) {
      this.props.eventListAction({
        isEvent: 1,
        pageSize: this.state.perPageCount,
        page: this.state.activePage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.getFilterData() 
      });
    }

    if (
      this.props.serverTimeListActivity &&
      this.props.serverTimeListActivity !== prevProps.serverTimeListActivity
    ) {
      let arrTimeResp = this.props.serverTimeListActivity.split("~~");
      if (arrTimeResp[0] === types.SERVER_TIME_LIST_SUCCESS) {
        let defaultStartDate = new Date(
          this.props.serverTimeList.current_date + "T00:00:00"
        );
        defaultStartDate = format(
          new Date(defaultStartDate.setDate(defaultStartDate.getDate() + 1)),
          "yyyy-MM-dd"
        );
        if (!eventId) {
          this.setState(
            { defaultStartDate: defaultStartDate, eventData: eventData },
            () => {
              this.onModalFormReset();
            }
          );
        } else {
          this.setState({ defaultStartDate: defaultStartDate });
        }
      }
    }

    if (
          downloadActivity &&
          (downloadStatus !== prevProps.downloadStatus ||
            downloadActivity !== prevProps.downloadActivity)
        ) {
          arrDn = downloadActivity.split("~~");
          if (arrDn[0] === types.EVENT_LIST_DOWNLOAD_SUCCESS) {
            this.setState(
              { exportQuote: this.formatQuoteArray(downloadEvents) },
              () => {
                setTimeout(() => {
                  let csvDownload = document.getElementById("CSVLinkDownload");
                  csvDownload.click();
                }, 500);
              }
            );
          } else if (arrDn[0] === types.EVENT_LIST_DOWNLOAD_ERROR) {
            this.setToasterState(true, MSG_CSV_DOWNLOAD_ERROR, false);
          }
        }
    
  }

  formatQuoteArray(array) {
      let exportQuote = [];
      if (array.length > 0) {
        array.map((item) => {
          let crewObj = {};
          crewObj["created_date"] = format(
            new Date(item.created_on),
            "dd/MM/yyyy"
          );
          crewObj["quote_number"] =
            item.quote_number === null ? MSG_NOT_GENERATED : item.quote_number;
          crewObj["quote_title"] = item.title;
          crewObj["venue"] =
            item.location_detail.location.venue === null ||
            item.location_detail.location.venue === undefined
              ? ""
              : item.location_detail.location.venue;
          crewObj["street1"] = item.location_detail.location.street1
            ? item.location_detail.location.street1
            : "";
          crewObj["street2"] = item.location_detail.location.street2
            ? item.location_detail.location.street2
            : "";
          crewObj["city"] = item.location_detail.location.city
            ? item.location_detail.location.city
            : "";
          crewObj["state"] = item.location_detail.location.state
            ? item.location_detail.location.state
            : "";
          crewObj["country"] = item.location_detail.location.country
            ? item.location_detail.location.country
            : "";
          crewObj["postcode"] = item.location_detail.location.postcode
            ? item.location_detail.location.postcode
            : "";
          crewObj["client"] = item.client_profile_details.company_name;
          const filteredStatus = this.state.eventStatus.filter(
            (x) => Number(x.statusCode) === Number(item.status)
          );
          crewObj["event_status"] = filteredStatus[0].statusString;
          crewObj["team_count_assigned"] = item.team_count_assigned;
          crewObj["team_count_total"] = item.team_count_total;
          crewObj["shift_count"] = item.shifts_count;
          crewObj["po_number"] =
            item.po_number === null || item.po_number === ""
              ? MSG_NOT_GENERATED
              : item.po_number;
          exportQuote.push(crewObj);
          return exportQuote;
        });
      }
      return exportQuote;
    }
  

  componentDidMount() {
    this.props.serverTimeAction();
    const { location, userGroupData } = this.props;
    const { eventData } = this.state;
   
    let userGroup = LOGIN_AFFILIATE_GROUP;
    let profileId = "";
    let assuserId = "";
    let profileCurrency = "";
    if (userGroupData && userGroupData !== undefined) {
      userGroup = userGroupData.user_group;
      profileId = userGroupData.profile_id;
      assuserId = userGroupData.associate_id;
      profileCurrency = userGroupData.profile_currency;
    }
    
    if (userGroup === LOGIN_AFFILIATE_GROUP) {
      document.body.classList.add("body-affiliate");
      this.setState({ isClientPage: false });
      eventData["affiliateId"] = Number(profileId);
    } else if (userGroup === LOGIN_CLIENT_GROUP) {
      eventData["affiliateId"] = Number(
        userGroupData.client_default_affiliate_id
      );
      eventData["clientId"] = Number(profileId);
      this.setState({ eventData });
      document.body.classList.add("body-client");
      this.setState({ isClientPage: true });
    } else {
      document.body.classList.add("body-super");
      this.setState({ isSuperAdminPage: true });
    }

    document.title = this.state.isEvent
      ? LBL_APP_NAME + " - " + LBL_EVENTS
      : LBL_APP_NAME + " - " + LBL_QUOTES;

    this.setState({
      userGroup: userGroup,
      profileId: profileId,
      assuserId: assuserId,
      profileCurrency: profileCurrency,
    });
  }

  showEvents = (e,eId) =>{
    if(eId && parseInt(eId,10)) {
      this.props.redirectToEvents(eId); 
    }
  }  

  render() {
    let {
      activePage,
      startIndex,
      endIndex,
      toastMessage,
      toastFlag,
      toastSuccess,
      eventStatus,
      isClientPage,
      isListLayout,
      quoteStatus,
      isSuperAdminPage,
      sortField,
      sortOrder,
    } = this.state;

    const {
      events,
      totalPage,
      status,
    } = this.props;
    let is_active = true;
    // let userGroupData = userGroupUrlCheck(this.props.location);
    let userGroup = LOGIN_AFFILIATE_GROUP;
    // if (userGroupData !== undefined) {
    //   userGroup = userGroupData.user_group;
    //   is_active = userGroupData.is_active;
      
    // }

    if (status === 401 || status === 403) {
      if (userGroup === LOGIN_AFFILIATE_GROUP) {
        return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
      } else if (userGroup === LOGIN_CLIENT_GROUP) {
        return <Redirect to={ROUTE_CLIENT_REFRESH} />;
      } else {
        return <Redirect to={ROUTE_REFRESH} />;
      }
    }

    let headers = [
      { label: "Created Date", key: "created_date" },
      { label: "Quote No", key: "quote_number" },
      { label: LBL_EVENT + " Title", key: "quote_title" },
      { label: "Venue", key: "venue" },
      { label: "Street1", key: "street1" },
      { label: "Street2", key: "street2" },
      { label: "City", key: "city" },
      { label: "State", key: "state" },
      { label: "Country", key: "country" },
      { label: "Postcode", key: "postcode" },
      { label: "Client", key: "client" },
      { label: LBL_EVENT + " Status", key: "event_status" },
      { label: "Team Count Assigned", key: "team_count_assigned" },
      { label: "Team Count Total", key: "team_count_total" },
      { label: "Shift Count", key: "shift_count" },
      { label: "PO Number", key: "po_number" },
    ];

    // let timeZone = getUserTimeZone(this.props.location);
    let isAddEvent = checkPermissions("events","modify");
    let isAddQuote = checkPermissions("events", "modify");

    let isClient = false;
    if(!this.state.eventListAdded){
      let new_event = [1,2,3,4,5,6,10]
      eventStatusData.map(eventItem => {
        if(new_event.indexOf(parseInt(eventItem.value)) != -1){
          eventItem.inputVal = 1;
        }else{
          eventItem.inputVal = 0;
        }
        return eventItem;
      });
      quotePageEventStatusData.map(eventItem => {
        if(new_event.indexOf(parseInt(eventItem.value)) != -1){
          eventItem.inputVal = 1;
        }else{
          eventItem.inputVal = 0;
        }
        return eventItem;
      });

      this.setState({eventStatusIds:new_event,eventListAdded:true},
        () => {
          this.onApplyFilterButton();
      });
    }
    

    return (
      <React.Fragment>
        <div className="col-md-12">
          <Toast
            toastDescription={toastMessage}
            toastFlag={toastFlag}
            toastSuccess={toastSuccess}
            closeToast={this.onCloseToast}
          />

          <div className="box">
  
              <div className="box-head" style={{overflow: 'visible'}}> 
                {/* <div className={isListLayout ? "dataTables_filter" : "hide"}>
                  <label>
                    <input
                      type="search"
                      className=""
                      placeholder={LBL_EVENT_TITLE + "/" + LBL_QUOTE_NO}
                      id="my-search-input"
                      onChange={this.onSearchQuote}
                      value={this.state.searchQuote}
                    />
                  </label>
                </div> */} 

                <div>
                  <div className="div-flex">
                    <div className="div-flex widthPerc60">
                        <div className="form-group multisel_textbox  div-flex">
                          <div className="text-09em div-flex-right" style={{textAlign: 'right'}}>
                            <div style={{alignItems: 'flex-end', textAlign: 'right'}}>
                              <button id="filterIcon" style={{cursor: 'context-menu'}}
                                onClick={this.onShowFilterBy}
                                className={ this.state.eventStatusIds.length ? "filter-btn  text-primary-filter" : "filter-btn text-primary"
                                }
                              >
                              <i className="las la-filter"></i>
                            </button> </div> &nbsp; 
                            <div style={{marginTop: '5px', textAlign: 'right'}}>{LBL_EVENT_STATUS} </div></div>
                            <div className="form-group select-input skills " style={{width: '60%'}}>
                                <CustomMultiSelect data={eventStatusData}  onChange={selected =>this.onEventStatusDataChange(selected,'event')} isTextBox={false}  needSelectAll={true} />
                            </div>
                            <div className=""><button className="btn btn-primary" onClick={e => this.onApplyFilterButton()}  style={{marginTop: '0px'}}>{LBL_APPLY}</button></div>
                        </div>
                    </div> 
                    <div className="div-flex widthPerc40">
                      <div>&nbsp;</div>
                      {isAddQuote && (
                        <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper" >
                          {this.props.hasOwnProperty("count") &&
                            this.props.count > 0 && (
                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                  <Tooltip
                                    id="download-tooltip"
                                    style={{ opacity: 0.4 }}
                                  >
                                    {LBL_DOWNLOAD}
                                  </Tooltip>
                                }
                              >
                                <Link
                                  to="#"
                                  onClick={(e) => this.onCSVDownload()}
                                  className="btn btn-outline-primary filter-btn"
                                >
                                  <i className="las la-file-download" style={{padding: '5px'}}></i>
                                </Link>
                              </OverlayTrigger>
                            )}
                        </div>
                      )}
                      
                      {this.state.exportQuote.length > 0 && (
                        <CSVLink
                          id="CSVLinkDownload"
                          className="hidden"
                          data={this.state.exportQuote}
                          headers={headers}
                          filename={
                            this.state.isEvent === 0
                              ? FILE_CSVDOWNLOAD_QUOTES 
                              : FILE_CSVDOWNLOAD_EVENTS
                          }
                        ></CSVLink>
                      )}
                    </div>
                  </div>
                </div>
                
              </div> 
           
            <div className="box-content">
              {isListLayout && (
                <>
                  
                  <div className="table-responsive">
                    <table
                      id="data-table"
                      className="table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>{LBL_SLNUM}</th>  

                          <th onClick={(e) => this.onSort(e, "title")} className="last-login-date spanPointer" >
                            {LBL_EVENT_TITLE}{" "}
                            <i className={
                                sortField == "title"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>

                          {isSuperAdminPage && (
                            <th onClick={(e) => this.onSort(e, "affiliate_profile__company_name") } className="last-login-date spanPointer"
                            >
                              {LBL_AFFILIATE}{" "}
                              <i className={
                                  sortField == "affiliate_profile__company_name"
                                    ? getSortClass(1, sortOrder)
                                    : getSortClass()
                                }
                              ></i>
                            </th>
                          )}

                          <th className="text-center min-width-125">
                            {LBL_QUOTE_NO}
                          </th>

                          <th onClick={(e) =>
                              this.onSort(e, "location__location")
                            }
                            className="location-name spanPointer"
                          >
                            {LBL_LOCATION}{" "}
                            <i
                              className={
                                sortField == "location__location"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>

                          <th onClick={(e) => this.onSort(e, "affiliate_profile__company_name") }
                            className={ isClientPage ? "spanPointer sector" : "hide" }
                          >
                            {LBL_AFFILIATE}{" "}
                            <i className={
                                sortField == "affiliate_profile__company_name"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>

                          <th  onClick={(e) => this.onSort(e, "status")}
                            className="sub-sector spanPointer max-width-125 text-center"
                          >
                            {LBL_EVENT_STATUS}{" "}
                            <i
                              className={
                                sortField == "status"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>

                          <th className="date-join text-center">
                            {LBL_TEAM_COUNT}
                          </th>

                          <th
                            onClick={(e) => this.onSort(e, "shifts_count")}
                            className="last-login-date spanPointer text-center"
                          >
                            {LBL_SHIFT_COUNT}{" "}
                            <i
                              className={
                                sortField == "shifts_count"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>

                          <th>
                            {LBL_Total_COST} ({LBL_CURRENCY_POUND}){" "}
                          </th>

                          <th>{LBL_PO}</th>

                        </tr>

                      </thead>
                      <tbody>
                        {this.props.count === 0 && (
                          <tr>
                            <td colSpan="13" className="text-center">
                              {MSG_NOT_FOUND}
                            </td>
                          </tr>
                        )}

                        {events.map((item, index) => {
                          let indeNum =
                            PAGENUMROWS_AFFILIATE * (activePage - 1) +
                            index +
                            1;
                          const filteredStatus = eventStatus.filter(
                            (x) => Number(x.statusCode) === Number(item.status)
                          );

                          let quoteStatusValue = 1;
                          let shiftCount = item.shifts_count;

                          let filteredQuoteStatus = [];
                          if (item.quote_set.length > 0) {
                            quoteStatusValue = item.quote_set[0].quote_status;
                            filteredQuoteStatus = quoteStatus.filter(
                              (x) =>
                                Number(x.statusCode) ===
                                Number(quoteStatusValue)
                            );
                          }

                          let quoteStatusString = "";
                          let quoteStatusClass = "";
                          if (filteredQuoteStatus.length > 0) {
                            quoteStatusString =
                              isClientPage &&
                              filteredQuoteStatus[0].statusCode === QUOTE_SENT
                                ? filteredQuoteStatus[0].clientStatusString
                                : filteredQuoteStatus[0].statusString;
                            quoteStatusClass =
                              filteredQuoteStatus[0].colorClass;
                          }


                          // FOR AFFILIATES ONLY, QUOTE CAN BE ACCEPTED IN STATUS - QUOTE_SENT, ESTIMATION & REESTIMATION - 30SEP2020

                          let eventNotCancelled = checkEventNotCancelled(
                            Number(item.status)
                          );
                          let showSchedule =
                            is_active === true &&
                            showScheduleBtn(
                              isClientPage,
                              shiftCount,
                              Number(item.status)
                            );
                          let showComplete =
                            is_active === true &&
                            showCompleteEventBtn(isClientPage, item.status);

                          let locStartDate = converDateToLocal(
                            item.start_date,
                            "+00:00",
                            "ddmmyyyy"
                          );
                          let locEndDate = converDateToLocal(
                            item.end_date,
                            "+00:00",
                            "ddmmyyyy"
                          );


                          return (
                            <tr key={item.id}>
                              <td>{indeNum}</td>

                              <td> 
                                {isSuperAdminPage ? (item.title) : <Link to="#" onClick={e => this.showEvents(e,item.id)} >{item.title}</Link>}
                                <br />
                                <small>
                                  {locStartDate + " - " + locEndDate}
                                </small>
                              </td>

                              {isSuperAdminPage && (
                                <td>
                                  {item.affiliate_profile_details.company_name}
                                </td>
                              )}

                              <td className="text-center">
                                {item.quote_number === null
                                  ? MSG_NOT_GENERATED
                                  : item.quote_number}
                                <br />
                                <span className={quoteStatusClass}>
                                  <small className="status-fill">
                                    {quoteStatusString}
                                  </small>
                                </span>
                              </td>

                              <td>{item.location_detail.location.venue} </td>

                              <td className={isClientPage ? "" : "hide"}>
                                {item.affiliate_profile_details.company_name}
                              </td>

                              <td
                                className={
                                  filteredStatus[0].colorClass +
                                  " text-center min-width-125 max-width-125"
                                }
                              >
                                <small className="status-fill">
                                  {isClientPage &&
                                  filteredStatus[0].statusCode === QUOTE_SENT
                                    ? filteredStatus[0].clientStatusString
                                    : filteredStatus[0].statusString}
                                </small>
                                <p className="td-p">
                                  <small>{item.cancel_reason}</small>
                                </p>
                              </td>

                              <td className="text-center">
                                {item.team_count_assigned
                                  ? item.team_count_assigned
                                  : 0}
                                /
                                {item.team_count_total
                                  ? item.team_count_total
                                  : 0}
                              </td>

                              <td className="text-center">
                                {item.shifts_count}
                              </td>
                              
                              <td className="">
                                <div className="div-right">{item.total_cost}</div>
                              </td>

                              <td>
                                {item.po_number === null ? "" : item.po_number}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <Paginator
                      totalPage={totalPage}
                      activePage={activePage}
                      startIndex={startIndex}
                      endIndex={endIndex}
                      onPagePrevious={this.onPagePrevious}
                      onPageUp={this.onPageUp}
                      onPageNext={this.onPageNext}
                    />
                    <div className="clear-b-scroll-sector">&nbsp;</div>
                    <div className="clear-b-scroll-sector">&nbsp;</div>
                    <div className="clear-b-scroll-sector">&nbsp;</div>
                  </div>
                </>
              )}
              {/* {!isListLayout && (
                <>
                  <EventCalendarView
                    showQuoteDetails={this.showQuoteDetails}
                    {...this.state}
                    timeZone={timeZone}
                  />
                </>
              )} */}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    events: state.event.events,
    eventData: state.event.item,
    totalPage: state.event.totalPage,
    status: state.event.status,
    activity: state.event.activity,
    subactivity: state.event.activity,
    numRows: state.event.numRows,
    count: state.event.count,
    errorData: state.event.errorData,
    isFilterOn: state.commons.isFilterOn,
    eventId: state.event.eventId,
    eventPopupId: state.event.eventPopupId,
    dashboardActionRequired: state.commons.fromActionRequired,
    serverTimeList: state.serverTimeList.serverTimeList,
    serverTimeListActivity: state.serverTimeList.serverTimeListActivity,
    downloadEvents: state.event.downloadEvents,
    downloadStatus: state.event.downloadStatus,
    downloadActivity: state.event.downloadActivity,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      eventListAction: eventListAction,
      clearAction: clearAction,
      fromDashboard: fromDashboard,
      serverTimeAction: serverTimeAction,
      eventListDownloadAction: eventListDownloadAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(ClientEvents);
